import merge from 'lodash/merge';
import { LOGO_URL, AUTH0_METADATA_CLAIM } from 'app/constants';
import { MobileAnalyticsServiceModule } from 'services/tracking/mobileApps/mobileAnalytics.service';
import { Auth0AuthServiceModule } from 'services/auth/auth0auth.service';

import { PhoneFilterModule } from 'filters/phone.filter';

import { CheckoutComponentsModule } from './components/checkoutComponents.module';
import { CheckoutServiceModule } from './checkout.service';

import template from './checkout.html';
import './checkout.scss';

export const CheckoutComponentModule = angular
    .module('app.components.checkout.checkoutComponent', [
        Auth0AuthServiceModule,
        CheckoutServiceModule,
        CheckoutComponentsModule,
        PhoneFilterModule,
        MobileAnalyticsServiceModule
    ]).component('checkout', {
        template,
        bindings: {
            cart: '<',
            expireTrialInFiveMinutes: '<',
            hideBackButton: '<',
            isModal: '<',
            materialTheme: '@',
            onBackClick: '<',
            onExitCheckout: '&',
            onPurchaseComplete: '&',
            returnUrl: '<',
            couponCode: '<',
            showCouponCodeField: '<',
            trialDaysRemaining: '<',
            isTrial: '<',
            showAlternate: '<',
            hasAccount: '<'
        },
        controller: class CheckoutComponent {
            constructor($window, checkoutService, $q, mobileAnalyticsService, auth0AuthService, $cookies) {
                'ngInject';

                angular.extend(this, {
                    user: { isLoggedIn: false },
                    selectedPaymentMethod: 'card',
                    isSignupFormValid: false,
                    purchaseComplete: false,
                    $window,
                    $cookies,
                    checkoutService,
                    auth0AuthService,
                    $q,
                    mobileAnalyticsService,
                    LOGO_URL
                });
            }

            $onInit() {
                this.initData();
                this.mobileAnalyticsService.trackEvent('Order:Payment', {});
                this.onPaymentMethodSelected = this.onPaymentMethodSelected.bind(this);
            }

            initData() {
                this.loading = true;
                let promises = [
                    this.checkoutService.createUser(),
                    this.auth0AuthService.isAuthenticated().then((authenticated) => {
                        if (authenticated) {
                            this.$cookies.put('loginTimestamp', Date.now(), { secure: true });
                            this.$window.dataLayer.push({
                                event: 'storeLogin'
                            });
                            return this.getLoggedInUserDetails();
                        }
                    })
                ];
                if (!this.cart.planDetails) promises.push(this.getPlanDetails());
                this.$q.all(promises).then(([user]) => {
                    merge(this.user, user);
                    this.loading = false;
                    this.checkoutService.logAddToCart(this.cart.planDetails);
                    this.checkoutService.logCheckoutStep(this.checkoutService.STEP_ENTRANCE, this.cart.planDetails);
                });
            }

            getPlanDetails() {
                return this.checkoutService.getPlanDetails(this.cart.planId).then((planDetails) => {
                    this.cart.planDetails = planDetails;
                });
            }

            getLoggedInUserDetails() {
                return this.checkoutService.getLoggedInUserDetails()
                    .then((details) => {
                        if (details.user) {
                            details.user.contactInfo = details.user[AUTH0_METADATA_CLAIM];
                        }

                        merge(
                            this.user,
                            this.checkoutService.setDetailsToUser(
                                details.user,
                                details.storeInfo,
                                details.paymentMethod
                            )
                        );

                        this.user.forceEdit = false;
                        this.hasAccount = details.user.isLoggedIn && details.user.payment
                            && details.user.payment.lastFour && details.user.payment.lastFour.length;
                        return this.user;
                    });
            }

            backToMarketing() {
                this.checkoutService.logRemoveFromCart(this.cart.planDetails);
                if (this.onBackClick) {
                    this.onBackClick();
                } else {
                    this.$window.location = this.returnUrl;
                }
            }

            onSignupFormValidityChange(isValid) {
                this.isSignupFormValid = isValid;
            }

            onCouponEntered(coupon) {
                this.coupon = coupon;
            }

            _onPurchaseComplete() {
                this.purchaseComplete = true;
                this.$cookies.remove('friendCode');
                this.mobileAnalyticsService.trackEvent('Order:Success', {});
                this.onPurchaseComplete();
            }

            onLogout() {
                this.checkoutService.createUser().then((user) => {
                    this.user = user;
                });
            }

            _onExitCheckout() {
                if (this.isModal) this.onExitCheckout();
                else this.$window.location = this.$window.location.origin;
            }

            onPaymentMethodSelected(selected) {
                this.selectedPaymentMethod = selected;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/checkout/checkout.component.js